module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Translation-c2592af8414a313f79042e3d67805d1c.png";